/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { ContentValue } from '@glint/template';
import type { Select } from 'ember-power-select/components/power-select';
import type { IAlignment, IBtnColor, TButtonSize } from 'volta/components/bv-btn';

export interface BvSelectTriggerSignature {
  Args: {
    verticalPosition?: 'auto' | 'above' | 'below';
    hideCaret?: boolean;
    allowClear?: boolean;
    prefix?: ContentValue;
    suffix?: ContentValue;
    placeholder?: boolean;
    selectedPath?: string;
    isLoading?: boolean;
    disabled?: boolean;
    focused?: boolean;
    alignText?: IAlignment;
    fill?: boolean;
    outline?: boolean;
    rounded?: boolean;
    plain?: boolean;
    subtle?: boolean;
    size?: TButtonSize;
    tooltipText?: string;
    color?: IBtnColor;
    iconRight?: string;
    iconLeft?: string;
    select?: Select;
  };
  Blocks: {
    default: [unknown, unknown];
  };
}

export default class BvSelectTriggerComponent extends Component<BvSelectTriggerSignature> {
  @action
  clear(e: Event) {
    e.stopPropagation();
    this.args.select?.actions.select(null);
    return e.type !== 'touchstart';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelect::Trigger': typeof BvSelectTriggerComponent;
    'bv-select/trigger': typeof BvSelectTriggerComponent;
  }
}
